import { render, staticRenderFns } from "./LastWeekConfirmReservation.vue?vue&type=template&id=3b5bcc7f"
import script from "./LastWeekConfirmReservation.vue?vue&type=script&lang=js"
export * from "./LastWeekConfirmReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports